'use strict';

exports.__esModule = true;
exports.convertLinkObjectToUrl = convertLinkObjectToUrl;
exports.convertUrlToLinkObject = convertUrlToLinkObject;
exports.convertUrlToPageId = convertUrlToPageId;
exports.getAnchorDataId = getAnchorDataId;
exports.getPageId = getPageId;
exports.convertQueryParamsToObject = convertQueryParamsToObject;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var externalRegx = /^(http|https):\/\/(.*)/;
var mailtoRegx = /^mailto:([^\?]*)(?:\?subject=(.*)?)?/;
var pageRegx = /^\/([^ \?]*)[\?]?(.*)/;
var pageTopRegx = /^(\/?)([^ \?]*)#(top|SCROLL_TO_TOP)[\?]?(.*)/;
var pageBottomRegx = /^(\/?)([^ \?]*)#(bottom|SCROLL_TO_BOTTOM)[\?]?(.*)/;
var oldDocumentFormatRegx = /^document:\/\/(.*)/;
var newDocumentFormatRegx = /^wix:document:\/\/v1\/(.+)\/(.+)/;
var phoneRegx = /^tel:(.*)/;
var pageWithAnchor = /^\/([^ \?]*)#([^ \?]*)[\?]?(.*)/;
var samePageWithAnchor = /^#([^ \?]*)[\?]?(.*)/;
var ANCHOR_TYPE_TO_NAME = {
  SCROLL_TO_TOP: 'top',
  SCROLL_TO_BOTTOM: 'bottom'
};
var LinkType = {
  PAGE: 'PageLink',
  DYNAMIC_PAGE: 'DynamicPageLink',
  DYNAMIC_PAGE_WITH_QUERY_PARAMS: 'DynamicPageLinkWithQueryParams',
  EXTERNAL: 'ExternalLink',
  EMAIL: 'EmailLink',
  DOCUMENT: 'DocumentLink',
  PHONE: 'PhoneLink',
  PAGE_TOP: 'AnchorLink',
  PAGE_BOTTOM: 'AnchorLink',
  SAME_PAGE_ANCHOR_LINK: 'SamePageAnchorLink',
  ANCHOR: 'AnchorLink'
};

var SUPPORTED_TARGETS = ['_blank', '_self'];

var MASTER_PAGE_ID = 'masterPage';
var prefixTypes = {
  ROUTER_PREFIX_TYPE: 'router',
  DYNAMIC_PAGE_PREFIX_TYPE: 'dynamicPages'
};

var anchorLinkBaseTemplate = _lodash2.default.template('<%=linkObject.pageId%>#<%=linkObject.anchorDataId%>', { variable: 'linkObject' });
var pageLinkBaseTemplate = _lodash2.default.template('/<%=linkObject.pageId%>', { variable: 'linkObject' });

var UnsupportedLinkTypeError = function (_Error) {
  _inherits(UnsupportedLinkTypeError, _Error);

  function UnsupportedLinkTypeError() {
    _classCallCheck(this, UnsupportedLinkTypeError);

    var _this = _possibleConstructorReturn(this, _Error.call(this, 'Unsupported link type'));

    _this.name = 'UnsupportedLinkTypeError';

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, UnsupportedLinkTypeError);
    }
    return _this;
  }

  return UnsupportedLinkTypeError;
}(Error);

var UnsupportedTargetValueError = function (_Error2) {
  _inherits(UnsupportedTargetValueError, _Error2);

  function UnsupportedTargetValueError() {
    _classCallCheck(this, UnsupportedTargetValueError);

    var _this2 = _possibleConstructorReturn(this, _Error2.call(this, 'Unsupported target value'));

    _this2.name = 'UnsupportedTargetValueError';
    _this2.supportedTargets = SUPPORTED_TARGETS;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this2, UnsupportedTargetValueError);
    }
    return _this2;
  }

  return UnsupportedTargetValueError;
}(Error);

function isDynamicPageType(entryWithPrefix) {
  return entryWithPrefix.type === prefixTypes.DYNAMIC_PAGE_PREFIX_TYPE || entryWithPrefix.type === prefixTypes.ROUTER_PREFIX_TYPE;
}

function getDynamicPagePrefixFromUrl(siteStructurePrefixes, urlParts) {
  return _lodash2.default.find(siteStructurePrefixes, function (entry) {
    return entry.prefix === '/' + urlParts[0] && isDynamicPageType(entry);
  });
}

function getDynamicPageIdFromUrl(siteStructurePages, urlParts) {
  var page = _lodash2.default.find(siteStructurePages, { prefix: urlParts[0], type: 'template' });
  return _lodash2.default.get(page, 'id');
}

function getInnerRoute(parts, hasAnchor, hasQueryParams) {
  var partsWithoutQueryParams = parts;
  if (hasQueryParams) {
    partsWithoutQueryParams = _lodash2.default.dropRight(parts);
  }
  var partsWithoutPrefixAndSuffix = _lodash2.default.drop(hasAnchor ? _lodash2.default.dropRight(partsWithoutQueryParams) : partsWithoutQueryParams);
  return _lodash2.default.join(partsWithoutPrefixAndSuffix, '/');
}

function getPageParts(str) {
  var parts = _lodash2.default.split(str, '/');
  if (parts.length > 1) {
    var innerRoute = _lodash2.default.join(_lodash2.default.drop(parts), '/');
    return _lodash2.default.concat([], _lodash2.default.head(parts), innerRoute);
  }
  return parts;
}

var LINK_URL_TEMPLATES = {
  PageLink: {
    url: getPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes, siteStructurePages) {
      var pageParts = getPageParts(parts[1]);
      var pageLinkObj = {
        type: type,
        pageId: '#' + translateUriSeoToPageId(_lodash2.default.head(pageParts), siteStructurePages).pageId

      };
      if (parts.length === 3 && parts[2]) {
        _lodash2.default.assign(pageLinkObj, { queryParams: convertQueryParamsToObject(parts[2]) || '' });
      }
      var tpaInnerRoute = pageParts[1];
      if (tpaInnerRoute) {
        _lodash2.default.assign(pageLinkObj, { tpaInnerRoute: tpaInnerRoute });
      }
      return pageLinkObj;
    },
    regex: [pageRegx]
  },
  DocumentLink: {
    url: _lodash2.default.template('wix:document://v1/<%=linkObject.docId%>/<%=linkObject.name%>', { variable: 'linkObject' }), link: function link(type, parts) {
      return {
        type: type,
        docId: parts[1],
        name: _lodash2.default.isUndefined(parts[2]) ? '' : parts[2]
      };
    },
    regex: [oldDocumentFormatRegx, newDocumentFormatRegx]
  },
  PhoneLink: {
    url: _lodash2.default.template('tel:<%=linkObject.phoneNumber%>', { variable: 'linkObject' }), link: function link(type, parts) {
      return {
        type: type,
        phoneNumber: parts[1]
      };
    },
    regex: [phoneRegx]
  },
  EmailLink: {
    url: getEmailLinkTemplate,
    link: function link(type, parts) {
      var data = {
        type: type,
        recipient: _lodash2.default.escape(parts[1])
      };
      if (parts[2]) {
        data.subject = _lodash2.default.escape(parts[2]);
      }
      return data;
    },

    regex: [mailtoRegx]
  },
  ExternalLink: {
    url: _lodash2.default.template('<%=linkObject.url%>', { variable: 'linkObject' }), link: function link(type, parts, siteStructurePrefixes, siteStructurePages, target) {
      if (target && !_lodash2.default.includes(SUPPORTED_TARGETS, target)) {
        throw new UnsupportedTargetValueError();
      }
      return {
        type: type,
        url: _lodash2.default.template('<%= partA %>://<%= partB%>')({ partA: parts[1], partB: parts[2] }),
        target: target || '_blank'
      };
    },
    regex: [externalRegx]
  },
  DynamicPageLink: {
    url: getDynamicPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes) {
      var hasAnchor = _lodash2.default.startsWith(_lodash2.default.last(parts), '#');
      var routerData = getDynamicPagePrefixFromUrl(siteStructurePrefixes, parts);
      var data = {
        type: type,
        innerRoute: getInnerRoute(parts, hasAnchor) || '/',
        routerId: routerData.id
      };
      if (hasAnchor) {
        var anchorName = _lodash2.default.last(parts).replace('#', '');
        data.anchorDataId = _lodash2.default.get(_lodash2.default.invert(ANCHOR_TYPE_TO_NAME), anchorName, anchorName);
      }
      return data;
    },
    regex: [pageTopRegx, pageBottomRegx, pageWithAnchor, pageRegx]
  },
  DynamicPageLinkWithQueryParams: {
    url: getDynamicPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes) {
      var queryParams = _lodash2.default.last(parts);
      var hasAnchor = _lodash2.default.startsWith(parts[parts.length - 2], '#');
      var routerData = getDynamicPagePrefixFromUrl(siteStructurePrefixes, parts);
      var data = {
        type: LinkType.DYNAMIC_PAGE,
        innerRoute: getInnerRoute(parts, hasAnchor, true) || '/',
        routerId: routerData.id,
        queryParams: convertQueryParamsToObject(queryParams)

      };
      if (hasAnchor) {
        var anchorName = parts[parts.length - 2].replace('#', '');
        data.anchorDataId = _lodash2.default.get(_lodash2.default.invert(ANCHOR_TYPE_TO_NAME), anchorName, anchorName);
      }
      return data;
    },
    regex: [pageTopRegx, pageBottomRegx, pageWithAnchor, pageRegx]
  },
  AnchorLink: {
    url: getAnchorLinkTemplate, link: function link(type, parts, siteStructurePrefixes, pages, target, isExperimentOpen) {
      // TODO remove isExperimentOpen & target when merging bv_linkUtils_anchorlink_innerTpaRoute
      var anchorDataId = parts[2];

      var _translateUriSeoToPag = translateUriSeoToPageId(parts[1], pages),
          pageId = _translateUriSeoToPag.pageId,
          pageIdInSiteStructure = _translateUriSeoToPag.pageIdInSiteStructure;

      var anchorLinkObj = {
        type: type,
        pageId: '#' + pageId,
        anchorDataId: _lodash2.default.invert(ANCHOR_TYPE_TO_NAME)[anchorDataId] || anchorDataId
      };

      if (isExperimentOpen && isExperimentOpen('bv_linkUtils_anchorlink_innerTpaRoute') && !pageIdInSiteStructure) {
        var pageStartingWithPrefix = _lodash2.default.find(siteStructurePrefixes, function (_ref) {
          var type = _ref.type,
              prefix = _ref.prefix;
          return type === 'app' && _lodash2.default.startsWith(parts[0], prefix + '/');
        });
        if (pageStartingWithPrefix) {
          var tpaInnerRoute = _lodash2.default.trimStart('/' + parts[1], pageStartingWithPrefix.prefix);
          if (tpaInnerRoute) {
            _lodash2.default.assign(anchorLinkObj, {
              tpaInnerRoute: tpaInnerRoute,
              pageId: '#' + _lodash2.default.trimStart(pageStartingWithPrefix.prefix, '/')
            });
          }
        }
      }

      if (parts.length === 4 && parts[3]) {
        _lodash2.default.assign(anchorLinkObj, { queryParams: convertQueryParamsToObject(parts[3]) });
      }
      return anchorLinkObj;
    },
    regex: [pageWithAnchor]
  },
  SamePageAnchorLink: {
    url: getAnchorLinkTemplate, link: function link(type, parts) {
      var anchorDataId = parts[1];
      var samePageAnchorLinkObj = {
        type: LinkType.ANCHOR,
        anchorDataId: _lodash2.default.invert(ANCHOR_TYPE_TO_NAME)[anchorDataId] || anchorDataId,
        pageId: '#' + MASTER_PAGE_ID
      };
      if (parts.length === 3 && parts[2]) {
        _lodash2.default.assign(samePageAnchorLinkObj, { queryParams: convertQueryParamsToObject(parts[2]) });
      }
      return samePageAnchorLinkObj;
    },
    regex: [samePageWithAnchor]
  }
};

function getUrlParts(regExpArr, value, type) {
  if (type === LinkType.DYNAMIC_PAGE || type === LinkType.DYNAMIC_PAGE_WITH_QUERY_PARAMS) {
    return getDynamicPageParts(value);
  }
  var regexp = _lodash2.default.find(regExpArr, function (regExpItem) {
    return regExpItem.test(value);
  });
  var parts = value.match(regexp);
  parts = parts ? parts : [];
  return parts;
}

function getDynamicPageParts(str) {
  var pageRegRes = str.match(pageRegx);
  var parts = pageRegRes[1].replace('#', '/#').split(/[\/]+/);
  var hasQueryParam = _lodash2.default.includes(str, '?');
  if (hasQueryParam) {
    parts.push(_lodash2.default.last(pageRegRes));
  }
  return parts;
}

function getAnchorName(anchorDataId) {
  return ANCHOR_TYPE_TO_NAME[anchorDataId] || anchorDataId;
}

function getDynamicPagePrefix(siteStructurePrefixes, linkObject) {
  var routerConfig = _lodash2.default.find(siteStructurePrefixes, { id: linkObject.routerId });
  return routerConfig && routerConfig.prefix;
}

function getDynamicPageLinkTemplate(linkObject, siteStructurePrefixes) {
  var dynamicPageSuffix = !linkObject.innerRoute || linkObject.innerRoute === '/' ? '' : '/' + linkObject.innerRoute;
  var route = getDynamicPagePrefix(siteStructurePrefixes, linkObject) + dynamicPageSuffix;

  var anchorDataId = getAnchorName(linkObject.anchorDataId);
  var customLinkObject = {
    pageId: _lodash2.default.startsWith(route, '/') ? route : '/' + route,
    anchorDataId: anchorDataId
  };
  return customLinkObject.anchorDataId ? anchorLinkBaseTemplate(customLinkObject) : route;
}

function getPageLinkTemplate(linkObject, siteStructurePrefixes, siteStructurePages) {
  var pageId = getPageIdForURL(linkObject.pageId);
  var pageObj = _lodash2.default.find(siteStructurePages, { id: pageId });
  return pageObj ? pageObj.url : pageLinkBaseTemplate({ pageId: pageId });
}

function getEmailLinkTemplate(linkObject) {
  var templateString = 'mailto:<%=linkObject.recipient%>';
  if (_lodash2.default.has(linkObject, 'subject')) {
    templateString += '?subject=<%=linkObject.subject%>';
  }

  return _lodash2.default.template(templateString, { variable: 'linkObject' })(linkObject);
}

function getAnchorLinkTemplate(linkObject, siteStructurePrefixes, siteStructurePages) {
  var anchorName = getAnchorName(linkObject.anchorDataId);
  if (isMasterPage(extractPageId(linkObject.pageId))) {
    return '#' + anchorName;
  }

  var pageId = getPageIdForURL(linkObject.pageId);
  var pageObj = _lodash2.default.find(siteStructurePages, { id: pageId });
  return pageObj ? anchorLinkBaseTemplate({
    pageId: pageObj.url,
    anchorDataId: anchorName
  }) : anchorLinkBaseTemplate({
    pageId: _lodash2.default.startsWith(pageId, '/') ? pageId : '/' + pageId,
    anchorDataId: anchorName
  });
}

function getPageIdForURL(pageId) {
  pageId = extractPageId(pageId);
  if (isMasterPage(pageId)) {
    return '';
  }

  return pageId.replace('#', '');
}

function extractPageId(pageId) {
  if (!pageId) {
    return pageId;
  }

  if (_lodash2.default.isPlainObject(pageId)) {
    if (pageId.pageUriSEO) {
      return pageId.pageUriSEO;
    } else if (isMasterPage(pageId.id)) {
      return MASTER_PAGE_ID;
    }

    throw new Error('pageId object should contain pageUriSEO');
  }

  return pageId;
}

function translateUriSeoToPageId(uriSeo, siteStructurePages) {
  var isHomePage = uriSeo === '';
  var pageData = isHomePage ? _lodash2.default.find(siteStructurePages, 'isMainPage') : _lodash2.default.find(siteStructurePages, { url: '/' + uriSeo });
  var pageId = _lodash2.default.get(pageData, 'id', uriSeo);
  var pageIdInSiteStructure = !!_lodash2.default.get(pageData, 'id');
  return { pageId: pageId, pageIdInSiteStructure: pageIdInSiteStructure };
}

function isDynamicPage(urlParts, siteStructurePrefixes) {
  return !!getDynamicPagePrefixFromUrl(siteStructurePrefixes, urlParts);
}

function getDynamicPageType(str) {
  return _lodash2.default.includes(str, '?') ? LinkType.DYNAMIC_PAGE_WITH_QUERY_PARAMS : LinkType.DYNAMIC_PAGE;
}

function isMasterPage(pageId) {
  return pageId.replace('#', '') === MASTER_PAGE_ID;
}

function getLinkType(str, siteStructurePrefixes) {
  switch (true) {
    case externalRegx.test(str):
      return LinkType.EXTERNAL;
    case mailtoRegx.test(str):
      return LinkType.EMAIL;
    case samePageWithAnchor.test(str):
      return LinkType.SAME_PAGE_ANCHOR_LINK;
    case pageTopRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE_TOP;
    case pageBottomRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE_BOTTOM;
    case pageWithAnchor.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.ANCHOR;
    case pageRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE;
    case oldDocumentFormatRegx.test(str):
      return LinkType.DOCUMENT;
    case newDocumentFormatRegx.test(str):
      return LinkType.DOCUMENT;
    case phoneRegx.test(str):
      return LinkType.PHONE;
    default:
      throw new UnsupportedLinkTypeError();
  }
}

function convertLinkObjectToUrl(siteStructurePrefixes, linkObject, siteStructurePages) {
  if (!linkObject || !_lodash2.default.get(LINK_URL_TEMPLATES, [linkObject.type, 'url'])) {
    throw new Error('Provided link type is not supported');
  }
  var urlTemplate = _lodash2.default.get(LINK_URL_TEMPLATES, [linkObject.type, 'url']);
  return urlTemplate(linkObject, siteStructurePrefixes, siteStructurePages);
}

function convertUrlToLinkObject(siteStructurePrefixes, url, target, siteStructurePages, isExperimentOpen) {
  // TODO remove isExperimentOpen when merging bv_linkUtils_anchorlink_innerTpaRoute
  var type = getLinkType(url, siteStructurePrefixes);
  var urlParts = getUrlParts(LINK_URL_TEMPLATES[type].regex, url, type);
  var linkTemplate = _lodash2.default.get(LINK_URL_TEMPLATES, [type, 'link']);
  return linkTemplate(type, urlParts, siteStructurePrefixes, siteStructurePages, target, isExperimentOpen);
}

function convertUrlToPageId(siteStructurePrefixes, url, siteStructurePages, isExperimentOpen) {
  // TODO remove isExperimentOpen when merging bv_linkUtils_anchorlink_innerTpaRoute
  var link = convertUrlToLinkObject(siteStructurePrefixes, url, null, siteStructurePages, isExperimentOpen);
  switch (link.type) {
    case LinkType.PAGE:
      var pageId = getPageIdForURL(link.pageId);
      if (_lodash2.default.find(siteStructurePages, { id: pageId })) {
        return pageId;
      }
      return null;
    case LinkType.DYNAMIC_PAGE_WITH_QUERY_PARAMS:
    case LinkType.DYNAMIC_PAGE:
      var urlParts = getUrlParts(LINK_URL_TEMPLATES[link.type].regex, url, link.type);
      return getDynamicPageIdFromUrl(siteStructurePages, urlParts);
    default:
      throw new UnsupportedLinkTypeError();
  }
}

function getAnchorDataId(linkItem) {
  return getAnchorName(linkItem.anchorDataId);
}

function getPageId(linkItem) {
  return extractPageId(linkItem.pageId);
}

function convertQueryParamsToObject(query) {
  if (!_lodash2.default.isString(query)) {
    return {};
  }
  var queryStringArray = query.split('&');
  return _lodash2.default.reduce(queryStringArray, function (res, queryParam) {
    var splitedQueryParam = queryParam.split('=');
    res[splitedQueryParam[0]] = splitedQueryParam[1] ? decodeURIComponent(splitedQueryParam[1]) : null;
    return res;
  }, {});
}
//# sourceMappingURL=linkUtils.js.map